var map = {
	"./CO2.svg": "56b6",
	"./H2S.svg": "a74d",
	"./NH3.svg": "3e53",
	"./PM10.svg": "76ef",
	"./PM25.svg": "5ce4",
	"./add.svg": "c2a3",
	"./calendar.svg": "0870",
	"./catch.svg": "6061",
	"./choice.svg": "5440",
	"./create_staff.svg": "d243",
	"./crop.svg": "11fe",
	"./drug.svg": "6e98",
	"./edit.svg": "aa46",
	"./end.svg": "58db",
	"./feed.svg": "447a",
	"./fence.svg": "4c39",
	"./fertilizer.svg": "14b2",
	"./field.svg": "d957",
	"./fish-net.svg": "8372",
	"./harvest.svg": "77ef",
	"./home.svg": "6bbe",
	"./humidity.svg": "19d7",
	"./internet.svg": "73e0",
	"./land.svg": "cf83",
	"./leaf.svg": "7820",
	"./means.svg": "a3ff",
	"./microscope.svg": "a68d",
	"./pesticide.svg": "8bfb",
	"./plant.svg": "419b",
	"./process.svg": "d8bf",
	"./product.svg": "8d30",
	"./raw.svg": "bc08",
	"./safe.svg": "bd01",
	"./seed.svg": "9b2a",
	"./selection.svg": "0ebd",
	"./shovel.svg": "8b05",
	"./tally_normal.svg": "3a4f",
	"./tally_rengong.svg": "9568",
	"./tally_returnGood.svg": "4cbd",
	"./tally_sellfruit.svg": "3289",
	"./tally_sellseed.svg": "64e5",
	"./tally_shuidian.svg": "1770",
	"./tally_yingjian.svg": "c869",
	"./tally_zfbutie.svg": "0312",
	"./temperature.svg": "db88",
	"./tool.svg": "3495",
	"./user.svg": "b3b5",
	"./warning.svg": "7e6f",
	"./zoom-in.svg": "2f8f",
	"./zoom-out.svg": "3d7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fce";